import React from "react";
import "./UserBasketList.css";
import { useAuth } from "../../Auth/useAuth";
import { useCart } from "../../Carts/useCart";
import { Drawer } from "@material-ui/core";
import CartsList from "../../Carts/CartsList";
import { useState } from "react";
import UiButton, { UI_BUTTON_TYPE } from "../../ui/UiButton";
import UiBadge from "../../ui/UiBadge";

function UserBasketList({ disabledBtn = false }) {
  const [auth] = useAuth();
  const [carts] = useCart(auth.user?.client_profile?.id);
  const [isDrawerCartsOpen, setDrawerCartsOpen] = useState();
  const availableBaskets = carts?.carts;
  const count = availableBaskets?.length || 0;
  const isDisabled = !(count > 0) || disabledBtn;
  function onClick(e) {
    setDrawerCartsOpen(true);
  }

  return (
    <React.Fragment>
      <UiButton
        classNames={["user-baskets-button"]}
        buttonUiType={[
          isDisabled ? UI_BUTTON_TYPE.NO_BORDER : UI_BUTTON_TYPE.ONLY_BORDER,
        ]}
        disabled={isDisabled}
        onClick={onClick}
        content={
          <React.Fragment>
            <UiBadge disabled={isDisabled} content={count} />
            <span>{count === 0 ? "panier" : "paniers"} en attente</span>
          </React.Fragment>
        }
      />
      <Drawer
        open={isDrawerCartsOpen}
        anchor="left"
        onClose={() => setDrawerCartsOpen(false)}
      >
        <CartsList closeList={setDrawerCartsOpen} />
      </Drawer>
    </React.Fragment>
  );
}

export default UserBasketList;
